import React, { Component, PropTypes } from 'react';
import ga from 'react-ga';
import { canonicalPathname } from '../shared/lib/meta-tags/index';

const nodeEnv = (process.env.NODE_ENV ? process.env.NODE_ENV : 'development');
const envConfig = require(`../config/config-${nodeEnv}.json`);

function initGA() {
  if (nodeEnv === 'production' || nodeEnv === 'staging') {
    const GAid = envConfig ? envConfig.GAID : null;
    if (GAid) {
      try {
        ga.initialize(GAid, { debug: false });
        ga.plugin.require('ecommerce', { debug: false });

        // GA Google Optimize ID
        const GAGOid = envConfig ? envConfig.GAGOID : null;
        if (GAGOid) {
          ga.ga('require', GAGOid);
        }
      } catch (e) {
        console.log('GA init error:', e);
      }
    } else {
      console.log('Not initializing GA');
    }
  }
}

initGA();

const withTracker = (WrappedComponent, options = {}) => {
  const trackPage = (props) => {
    const { location } = props;
    const { pathname } = location;
    const canonical = canonicalPathname(pathname);

    ga.set({
      page: canonical,
      ...options,
    });

    ga.pageview(canonical);
  };

  const HOC = class extends Component {

    componentDidMount() {
      trackPage(this.props);
    }

    componentWillReceiveProps(nextProps) {
      const currentPage = this.props.location.pathname;
      const nextPage = nextProps.location.pathname;

      if (currentPage !== nextPage) {
        trackPage(nextProps);
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };

  HOC.propTypes = {
    location: PropTypes.object,
  };

  return HOC;
};

export default withTracker;



// WEBPACK FOOTER //
// ./server/ga-page-tracker.js